(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-variants"] && !Shopify.designMode) return;
  try {
    // Keep the hidden internal "Color" option in sync with the product's real
  // color (from its title) so add-to-cart submits a correctly labeled variant.
  if (!window.__formeColorSync) {
    window.__formeColorSync = true;

    var formeColorFix = function () {
      document.querySelectorAll('variant-picker').forEach(function (vp) {
        var pid = vp.getAttribute('data-product-id');
        if (!pid) return;
        var src = document.querySelector(
          'color-siblings[data-product-id="' + pid + '"][data-internal-color]'
        );
        if (!src) return;
        var want = src.getAttribute('data-internal-color');
        vp.querySelectorAll('fieldset').forEach(function (fs) {
          var colorInput = fs.querySelector(
            'input[name^="Color-"], input[name^="Цвят-"]'
          );
          if (!colorInput) return;
          var target = Array.prototype.find.call(
            fs.querySelectorAll('input'),
            function (i) {
              return i.value === want;
            }
          );
          if (target && !target.checked) target.click();
        });
      });
    };

    var formeColorFixQueued = false;
    var queueFix = function () {
      if (formeColorFixQueued) return;
      formeColorFixQueued = true;
      // setTimeout instead of requestAnimationFrame: rAF is paused in
      // hidden/background tabs, which would leave the wrong variant selected
      setTimeout(function () {
        formeColorFixQueued = false;
        formeColorFix();
      }, 50);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', queueFix);
    } else {
      queueFix();
    }
    if (window.customElements) {
      customElements.whenDefined('variant-picker').then(queueFix);
    }
    new MutationObserver(queueFix).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
  } catch(e) { console.error(e); }
})();

})();
